@use '../../../../app/styles/common/mixins';

.contacts {
  align-items: center;
}

.contactButton {
  @include mixins.laptop {
    padding: var(--spasing16) var(--spasing24);
  }
}
